export const apiAddress = process.env.REACT_APP_API_ADDRESS;

export const apiAddressMachineQuery = process.env.REACT_APP_API_MACHINE_QUERY_ADDRESS;
export const apiTokenMachineQuery = process.env.REACT_APP_API_MACHINE_QUERY_TOKEN;

export const reCaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

export const whitelabelDomain = process.env.REACT_APP_DOMAIN_WHITELABEL || '';
